module.exports = __webpack_public_path__ + "static/media/excellence_2.d2c119da.jpeg";